export const projectsData = [
  {
    id: 1,
    title:
      "Traffic sign classification and recognition in real time using the CNN model ...",
    date: "2021-10-04",
    img: "https://cse.mbstu.ac.bd/storage/259/no-uturn.png",
    alt: "article about Traffic sign classification and recognition in real time using the CNN model",
  },
  {
    id: 2,
    title: "Voice command based e-mail system for physically challenged people",
    date: "2021-10-14",
    img: "https://cse.mbstu.ac.bd/front/theme1/images/default/preview.png",
    alt: "article about Voice command based e-mail system for physically challenged people",
  },
  {
    id: 3,
    title: "Internet Banking",
    date: "2021-05-05",
    img: "https://cse.mbstu.ac.bd/storage/76/8-tips-to-sidestep-the-mines-in-internet-banking.jpg",
    alt: "article about Internet Banking",
  },
  {
    id: 4,
    title:
      "A deep learning approach for Opinion Mining and Sentiment Analysis from text ...",
    date: "2021-10-04",
    img: "https://cse.mbstu.ac.bd/storage/258/Picture3.png",
    alt: "article about A deep learning approach for Opinion Mining and Sentiment Analysis from text",
  },
  {
    id: 5,
    title: "SMS Push Service",
    date: "2021-05-05",
    img: "https://cse.mbstu.ac.bd/storage/75/download.jpg",
    alt: "article about SMS Push Service",
  },
  {
    id: 6,
    title: "Real Time Gross Settlement",
    date: "2021-04-29",
    img: "https://cse.mbstu.ac.bd/storage/70/images.jpg",
    alt: "article about Real Time Gross Settlemen",
  },
  {
    id: 7,
    title: "Nationwide Collection Services (NCS)",
    date: "2021-04-29",
    img: "https://cse.mbstu.ac.bd/storage/72/icsystem2_logo.png",
    alt: "article about Nationwide Collection Services (NCS)",
  },
  {
    id: 8,
    title: "Fighter Controller Training Unit Simulator",
    date: "2021-04-29",
    img: "https://cse.mbstu.ac.bd/storage/73/1-%281%29.jpg",
    alt: "article about Fighter Controller Training Unit Simulator",
  },
];
